import { Chip } from "@mui/material";
import { Link } from "react-router-dom";

const UserButton = (props) => {
  return (
    <Chip
      label="User"
      component={Link}
      to={"/user/" + props.userId}
      clickable
      variant="outlined"
      sx={{ m: 0.5 }}
    />
  );
};

export default UserButton;
